import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {TranslateService} from "@ngx-translate/core";
import {Observable, switchMap} from "rxjs";

@Component({
  selector: 'app-dialog-confirm',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './dialog-confirm.component.html',
  styleUrl: './dialog-confirm.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogConfirmComponent {

  constructor( public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, action: string }
  ) {
  }

  static openDeleteDialog(dialog: MatDialog, translate: TranslateService): Observable<any> {
    return translate.get(['DELETE-DIALOG.title', 'DELETE-DIALOG.message', 'DELETE-DIALOG.action']).pipe(
      switchMap(translations => dialog.open(DialogConfirmComponent, {
        width: '400px',
        data: {
          title: translations['DELETE-DIALOG.title'],
          message: translations['DELETE-DIALOG.message'],
          action: translations['DELETE-DIALOG.action']
        }
      }).afterClosed())
    );
  }

}
